import { useEffect, useState } from 'react'
import { CartCreateDocument, CartDocument, GQLCartCreateMutation, GQLCartCreateMutationVariables, GQLCartQuery, GQLCartQueryVariables, useCartCreateMutation, useCartLazyQuery, useCartLinesAddMutation, useCartQuery } from '../generated/graphql'
import { ApolloClient, useApolloClient } from '@apollo/client'


declare global {
  interface Window {
    cartId?: Promise<string | undefined>
  }
}
const getCartId = async <T>(client: ApolloClient<T>) => {
  if(window.cartId){
    return window.cartId
  } else {
    return window.cartId = new Promise<string | undefined>(async resolve => {
      const id = localStorage.getItem('cartId')
      if(id){
        const res = await client.query<GQLCartQuery, GQLCartQueryVariables>({
          query: CartDocument,
          variables: {
            id
          }
        })
        if(res.data.cart){
          resolve(id)
          return
        }
      }
  
      const res = await client.mutate<GQLCartCreateMutation, GQLCartCreateMutationVariables>({
        mutation: CartCreateDocument,
        variables: {
          input: {}
        }
      })
      const cart = res.data?.cartCreate?.cart
      if(cart){
        localStorage.setItem('cartId', cart.id)
        resolve(cart.id)
      }
      resolve(undefined)
    })
  }
}

export const useCartId = () => {
  const [id, setId] = useState<string | null>(null)
  const client = useApolloClient()
  useEffect(() => {
    getCartId(client).then(id => setId(id ?? null))
  }, [])
  return id
}